/**
 * To be used with the "onKeyPress" prop. Wrap whatever function you intend on
 * passing and guarantee only the enter/return key triggers the function. For
 * accessibility usage when non standard elements are used as buttons.
 */

type Event = {
  which: number;
  keyCode: number;
};

const kp = (func: Function) => (e?: Event) => {
  const { which, keyCode } = e || {};
  if (e && (which === 13 || keyCode === 13)) {
    return func();
  }

  return null;
};

export default kp;
